export default __webpack_public_path__ + "8492194c2948f8f99b37af882fb71479.png";